import { render, staticRenderFns } from "./ThirdPartyDataObject.vue?vue&type=template&id=0676b9a5&scoped=true&"
import script from "./ThirdPartyDataObject.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyDataObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676b9a5",
  null
  
)

export default component.exports